module.exports = __webpack_public_path__ + "static/img/12.69e8923.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/12.png
// module id = 4mIU
// module chunks = 0